// App.js
import React from 'react';
import './App.css'; // For global styles or reset
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Amenities from './components/Amenities';
import Rooms from './components/Rooms';
import Gallery from './components/Gallery';
import Booking from './components/Booking';
import Contact from './components/Contact';
import Footer from './components/Footer';
import useReveal from './hooks/useReveal';

function App() {
  useReveal(); // Initialize reveal animations

  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Amenities />
      <Rooms />
      <Gallery />
      <Booking />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
